import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function ufReducer(state = initialState.ufs, action){
    switch(action.type) {
        case types.LISTAR_UF:
            
            return action.ufs;
        default:
            return state;
    }
}


/** WEBPACK FOOTER **
 ** ./src/components/reduces/ufReducer.js
 **/